module.exports = __webpack_public_path__ + "img/Artwork2.348cffd1.svg";